import { useGetLatestExamQSetUsageReportCreatedAtQuery } from '@report/graphql';
import { Link } from '@report/router';
import { ArrowBackRoundedIcon, Button, PageHeader, Text } from '@shared/components';
import { formatDateTime } from '@shared/utils';

export default function QSetUsageReportPageHeader() {
  const { data } = useGetLatestExamQSetUsageReportCreatedAtQuery();

  const latestCreatedAt = formatDateTime(
    data?.reportGetLatestExamQSetUsageReportCreatedAt.latestCreatedAt,
  );

  return (
    <PageHeader
      title='รายงานสถานะการใช้งานชุดข้อสอบ'
      linkAdornment={
        // TODO: replace with NavigateBackLink component in report/components package
        <Button
          variant='text'
          component={Link}
          to='/reports'
          sx={{
            p: 0,
            m: 0,
            justifyContent: 'flex-start',
            color: (theme) => theme.palette.text.secondary,
          }}
          startIcon={<ArrowBackRoundedIcon />}
        >
          Back
        </Button>
      }
      subtitleSection={
        <>
          <Text variant='body2' color='text.secondary'>
            สรุปการใช้งานชุดข้อสอบแต่ละชุด พร้อมจำนวนผู้สอบ อัตราผ่าน และค่าเฉลี่ยคะแนน
          </Text>
          <Text variant='body2' color='text.secondary'>
            อัปเดตข้อมูลล่าสุด: {latestCreatedAt}
          </Text>
        </>
      }
    />
  );
}
